import * as React from "react";
import "../../css/Header.css";

import { Row, Col, Container } from "react-bootstrap";

export class Header extends React.PureComponent {
  render() {
    return (
      <Container>
        <Row>
          <Col>
            <h1 className="appName">GRASP</h1>
          </Col>
        
        </Row>
      </Container>
    );
  }
}

export default Header;
